import React from 'react';
import { connect } from 'react-redux';

class ReorderIndividualItem extends React.Component {

    constructor(props) {
        super(props);
    }


    printToppingPortion(theCartTopping) {
        if (theCartTopping.portion == "H1") {
            return " (First Half Only)";
        }
        else if (theCartTopping.portion == "H2") {
            return " (Second Half Only)";
        }
        else {
            return "";
        }
    };

    printItemPrice(theItem, price_id) {

        let printPrice = "";
        theItem.prices.forEach((thePrice) => {
            if (thePrice.size_id == price_id && thePrice.price > 0) {
                printPrice = " - "+thePrice.price;
            }
        })

        return printPrice;
    };

    printChoicePrice(theChoice, isMultiple = false) {
        let thePrice = 0.00;
        if (isMultiple) {
            thePrice = parseFloat(theChoice.price);
        }
        else {
            thePrice = parseFloat(theChoice.item_price);
        }

        if (thePrice > 0) {
            return " - "+thePrice.toFixed(2);
        }
        else {
            return "";
        }
    };

    printPrice(theAddon) {

        const thePrice = parseFloat(theAddon.price);

        if (theAddon.price > 0) {
            return " - "+thePrice.toFixed(2);
        }
        else {
            return "";
        }
    };

    render() {
        const { index, item } = this.props;
        return (
            <div>
                {/* <div className="receipt-line">


                    <p className="paragraph in-receipt">{item.name}({item.quantity}x)</p>
                </div> */}
                <div className="cart-reorder-item">
                    <div className="content">
                        <p className="reorder-item-title"> {item.name}({item.quantity}x)</p>
                        {item.details.map((theDetail, theDetailIndex) => {
                            return (
                                <div key={"item-"+index+"-"+theDetailIndex}>
                                    <p className="cart-item-detail">- {theDetail.description}</p>
                                    {(theDetail.details) && theDetail.details.map((subDetail, subDetailIndex) => {
                                        return <p key={"item-"+index+"-"+theDetailIndex+"-"+subDetailIndex} className="cart-item-sub-detail">- {subDetail}</p>
                                    })}
                                </div>
                            );
                        })}
                    </div>
                    <div className="padding">
                    </div>
                    <p className="cart-item-price">{parseFloat(item.totalPrice).toFixed(2)}</p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
      currentLocation: state.currentLocation.info
    };
  };

export default connect(mapStateToProps)(ReorderIndividualItem);